import { render, staticRenderFns } from "./SkyMap.vue?vue&type=template&id=2490fe7c&scoped=true&"
import script from "./SkyMap.vue?vue&type=script&lang=js&"
export * from "./SkyMap.vue?vue&type=script&lang=js&"
import style0 from "./SkyMap.vue?vue&type=style&index=0&id=2490fe7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2490fe7c",
  null
  
)

export default component.exports